export const routes = [
  ...require('./person/routes').routes,
  ...require('./personconfirmationdata/routes').routes
]
